// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
export var common = {
    white: '#ffffff',
    black: '#000000',
    transparent: 'transparent'
};

//# sourceMappingURL=common.js.map